module.exports = __webpack_public_path__ + "static/EnmTX_BosGuardian_L_A_cl-0d3540367294682d7b5aa033279e0d9b.gif";